import { MapPin, Mail, Phone, MessageCircle, Clock, Navigation } from "lucide-react";
import { BRAND, LOCATION, whatsappUrl } from "../data/content";
import { openDirections } from "../lib/directions";

export const Contacto = () => {
    return (
        <section
            id="contacto"
            data-testid="contacto-section"
            className="relative py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="mx-auto max-w-2xl text-center">
                    <div className="mb-6 inline-flex items-center gap-3">
                        <span className="h-px w-12 bg-gold" />
                        <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                            Contacto
                        </span>
                        <span className="h-px w-12 bg-gold" />
                    </div>
                    <h2 className="font-display text-4xl leading-tight text-foreground sm:text-5xl md:text-6xl">
                        ¿Listos para una
                        <span className="text-gold"> serenata inolvidable?</span>
                    </h2>
                    <p className="mt-5 text-muted-foreground md:text-lg">
                        Reserva directamente por WhatsApp. Respondemos en minutos.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 overflow-hidden rounded-2xl border border-gold/30 lg:grid-cols-5">
                    {/* Info side */}
                    <div className="relative flex flex-col justify-between bg-card p-8 md:p-12 lg:col-span-2">
                        <div>
                            <h3 className="font-display text-3xl text-foreground">
                                Ubícanos
                            </h3>
                            <div className="mt-2 h-px w-12 bg-gold" />
                            <p className="mt-5 text-muted-foreground">
                                Mariachi Mexicanísimo — atendemos en Armenia y todo el Eje
                                Cafetero: Calarcá, Circasia, La Tebaida, Montenegro, Quimbaya,
                                Pereira y Manizales.
                            </p>
                        </div>

                        <div className="mt-10 space-y-5">
                            <ContactRow
                                icon={<MapPin className="h-5 w-5" />}
                                label="Dirección"
                                value={BRAND.address}
                            />
                            <ContactRow
                                icon={<Phone className="h-5 w-5" />}
                                label="Teléfono"
                                value={BRAND.phoneDisplay}
                                href={`tel:+57${BRAND.phone}`}
                                testid="contact-phone"
                            />
                            <ContactRow
                                icon={<Mail className="h-5 w-5" />}
                                label="Correo"
                                value={BRAND.email}
                                href={`mailto:${BRAND.email}`}
                                testid="contact-email"
                            />
                            <ContactRow
                                icon={<Clock className="h-5 w-5" />}
                                label="Horario"
                                value="24/7 — incluso madrugadas"
                            />
                        </div>

                        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3">
                            <a
                                href={whatsappUrl()}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-whatsapp-btn"
                                className="col-span-2 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gold px-4 py-3.5 text-sm font-bold text-black transition hover:scale-[1.02] hover:shadow-[0_0_30px_hsl(var(--gold)/0.5)] sm:col-span-1"
                            >
                                <MessageCircle className="h-4 w-4" />
                                WhatsApp
                            </a>
                            <button
                                type="button"
                                onClick={openDirections}
                                data-testid="contact-directions-btn"
                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-gold px-4 py-3.5 text-sm font-bold text-gold transition hover:bg-gold hover:text-black"
                            >
                                <Navigation className="h-4 w-4" />
                                Cómo llegar
                            </button>
                            <a
                                href={`tel:+57${BRAND.phone}`}
                                data-testid="contact-call-btn"
                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-border px-4 py-3.5 text-sm font-bold text-foreground transition hover:border-gold hover:text-gold"
                            >
                                <Phone className="h-4 w-4" />
                                Llamar
                            </a>
                        </div>
                    </div>

                    {/* Map side */}
                    <div className="relative min-h-[380px] lg:col-span-3">
                        <iframe
                            title="Ubicación Mariachi Mexicanísimo, Armenia Quindío"
                            data-testid="google-map"
                            src={`https://www.google.com/maps?q=${LOCATION.lat},${LOCATION.lng}&output=embed&z=17`}
                            className="absolute inset-0 h-full w-full border-0 grayscale-[30%] contrast-[1.05]"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                        <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-gold/20" />

                        {/* Custom gold pin overlay — centered on the studio's address */}
                        <div className="pointer-events-none absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-full">
                            {/* ripple */}
                            <div className="relative">
                                <span className="absolute left-1/2 top-full h-3 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full bg-black/40 blur-sm" />
                            </div>
                            <div className="relative animate-bounce" style={{ animationDuration: "2.4s" }}>
                                {/* pulse rings */}
                                <span className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2">
                                    <span className="absolute left-1/2 top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/40 animate-ping" />
                                </span>
                                {/* Pin SVG */}
                                <svg viewBox="0 0 48 60" className="h-14 w-14 drop-shadow-[0_8px_16px_rgba(0,0,0,0.45)]">
                                    <defs>
                                        <linearGradient id="pinGoldGrad" x1="0" x2="0" y1="0" y2="1">
                                            <stop offset="0%" stopColor="#F3E5AB" />
                                            <stop offset="50%" stopColor="#D4AF37" />
                                            <stop offset="100%" stopColor="#996515" />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        d="M24 2 C13 2 5 10 5 21 C5 34 24 58 24 58 C24 58 43 34 43 21 C43 10 35 2 24 2 Z"
                                        fill="url(#pinGoldGrad)"
                                        stroke="#7A4F0D"
                                        strokeWidth="1.5"
                                    />
                                    <circle cx="24" cy="21" r="7" fill="#0A0A0A" />
                                    <text x="24" y="25" textAnchor="middle" fontFamily="Manrope, sans-serif" fontWeight="800" fontSize="10" fill="#D4AF37">
                                        M
                                    </text>
                                </svg>
                            </div>
                            {/* Label badge */}
                            <div className="mt-1 -translate-y-2 whitespace-nowrap rounded-full border border-gold/60 bg-black/80 px-3 py-1 text-center text-[10px] font-bold uppercase tracking-[0.25em] text-gold backdrop-blur">
                                Armenia · Quindío
                            </div>
                        </div>

                        {/* "Cómo llegar" floating CTA over the map */}
                        <button
                            type="button"
                            onClick={openDirections}
                            data-testid="map-directions-btn"
                            className="pointer-events-auto absolute bottom-4 right-4 z-20 inline-flex items-center gap-2 rounded-full border border-gold bg-background/90 px-5 py-3 text-xs font-bold uppercase tracking-[0.2em] text-foreground shadow-lg backdrop-blur-md transition hover:scale-[1.03] hover:bg-gold hover:text-black"
                        >
                            <Navigation className="h-4 w-4 text-gold" />
                            Cómo llegar
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

const ContactRow = ({ icon, label, value, href, testid }) => {
    const content = (
        <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/5 text-gold">
                {icon}
            </div>
            <div>
                <div className="text-[10px] font-semibold uppercase tracking-[0.3em] text-muted-foreground">
                    {label}
                </div>
                <div className="mt-1 font-serif-pf text-base text-foreground md:text-lg">
                    {value}
                </div>
            </div>
        </div>
    );
    if (href) {
        return (
            <a
                href={href}
                data-testid={testid}
                className="block rounded-lg transition hover:bg-gold/5 hover:translate-x-1"
            >
                {content}
            </a>
        );
    }
    return content;
};

export default Contacto;
